export const getAdmin = /* GraphQL */ `
  query getAdmin {
    listAdmin {
      username
      _name
      surname
      email
    }
  }
`;

export const getCustomers = /* GraphQL */ `
  query getCustomers {
    listCustomers {
      crm_id
      ragione_sociale
      c_description
      state
      account_type
      timezone
      webhook_url
    }
  }
`;

export const getTechUsersByCustomer = /* GraphQL */ `
  query getTechUsersByCustomer($crm_id: String!) {
    listTechUsersByCustomer(crm_id: $crm_id) {
      username
      email
      _state
      policy_id
      billing_anchor_date
    }
  }
`;

export const getPoliciesTU = /* GraphQL */ `
  query getPolicies {
    listPolicies {
      policy_id
      policy_name
    }
  }
`;

export const getPolicies = /* GraphQL */ `
  query getPolicies {
    listPolicies {
      policy_id
      policy_name
      policy_description
      quota_metric
      quota_period
      quota_limit
      max_calls_per_day
    }
  }
`;

export const getWorkspacesByPolicy = /* GraphQL */ `
  query getWorkspacesByPolicy($policy_id: Int!) {
    listWorkspacesByPolicy(policy_id: $policy_id) {
      workspace_name
      n_calls
      start_time
      stop_time
      date_type
    }
  }
`;

export const getDBLayers = /* GraphQL */ `
  query getDBLayers($workspace_name: String!, $policy_id: Int!) {
    listDBLayers(workspace_name: $workspace_name, policy_id: $policy_id) {
      workspace_name
      policy_id
      layer_name
      tier
    }
  }
`;

export const getDomainsWS = /* GraphQL */ `
  query getDomainsWS {
    listDomains {
      domain_id
      domain_name
    }
  }
`;

export const getDomainsByWS = /* GraphQL */ `
  query getDomainsByWS($workspace_name: String!, $policy_id: Int!) {
    listDomainsByWorkspace(
      workspace_name: $workspace_name
      policy_id: $policy_id
    ) {
      domain_id
      domain_name
    }
  }
`;

export const getDomains = /* GraphQL */ `
  query getDomains {
    listDomains {
      domain_id
      domain_name
      domain_description
      polygon
    }
  }
`;

export const checkUserDomain = /* GraphQL */ `
  query checkUserDomain($domain_id: Int!) {
    checkUserDomain(domain_id: $domain_id) {
      result
    }
  }
`;

export const checkUserPolicy = /* GraphQL */ `
  query checkUserPolicy($policy_id: Int!) {
    checkUserPolicy(policy_id: $policy_id) {
      result
    }
  }
`;

export const getGroup = /* GraphQL */ `
  query getGroup($input: GetGroupInput!) {
    getGroup(input: $input) {
      success
      username
      groupName
    }
  }
`;

export const listGroups = /* GraphQL */ `
  query listGroups {
    listGroups {
      group_id
      group_name
      policy_id
    }
  }
`;

export const getUserGroups = /* GraphQL */ `
  query getUserGroups($username: String!) {
    getUserGroups(username: $username) {
      groupIds
    }
  }
`;

export const getAffectedUsersCount = /* GraphQL */ `
  query getAffectedUsersCount($policy_id: Int!) {
    getAffectedUsersCount(policy_id: $policy_id)
  }
`;

// ---------- STATISTICS

export const getCallsOverview = /* GraphQL */ `
  query getCallsOverview($year: Int!, $date_from: String, $date_to: String) {
    getCallsOverview(year: $year, date_from: $date_from, date_to: $date_to) {
      year
      total_calls
      unique_users
      most_used_service
      calls_today
      calls_with_geo
      unique_stations
      unique_workspaces
      most_used_workspace
      top_workspaces {
        name
        call_count
      }
      by_service {
        name
        call_count
      }
    }
  }
`;

export const getCallerBreakdown = /* GraphQL */ `
  query getCallerBreakdown(
    $year: Int!
    $username: String!
    $date_from: String
    $date_to: String
  ) {
    getCallerBreakdown(
      year: $year
      username: $username
      date_from: $date_from
      date_to: $date_to
    ) {
      username
      email
      total_calls
      services {
        name
        call_count
      }
      workspaces {
        name
        call_count
      }
      layers {
        name
        call_count
      }
      time_durations {
        name
        call_count
      }
    }
  }
`;

export const listStatisticsUsers = /* GraphQL */ `
  query listStatisticsUsers($year: Int!, $limit: Int, $date_from: String, $date_to: String) {
    listStatisticsUsers(year: $year, limit: $limit, date_from: $date_from, date_to: $date_to) {
      username
      email
      total_calls
    }
  }
`;

export const listTopCallers = /* GraphQL */ `
  query listTopCallers($year: Int!, $limit: Int, $date_from: String, $date_to: String) {
    listTopCallers(year: $year, limit: $limit, date_from: $date_from, date_to: $date_to) {
      username
      email
      customer_id
      total_calls
    }
  }
`;

export const listCallsByUser = /* GraphQL */ `
  query listCallsByUser($year: Int!, $username: String!, $date_from: String, $date_to: String) {
    listCallsByUser(year: $year, username: $username, date_from: $date_from, date_to: $date_to) {
      transaction_id
      username
      email
      service
      ip
      call_time
      lat
      lon
      height
      layers
      station_name
      time_range
      timezone
      workspace
      output_fmt
    }
  }
`;

export const listServiceStats = /* GraphQL */ `
  query listServiceStats($year: Int!, $date_from: String, $date_to: String) {
    listServiceStats(year: $year, date_from: $date_from, date_to: $date_to) {
      service
      call_count
      workspace_count
      layer_count
      time_duration_count
      timezone_count
      output_fmt_count
      workspaces {
        name
        call_count
      }
      layers {
        name
        call_count
      }
      time_durations {
        name
        call_count
      }
      timezones {
        name
        call_count
      }
      output_formats {
        name
        call_count
      }
    }
  }
`;

export const listDailyStats = /* GraphQL */ `
  query listDailyStats($year: Int!, $username: String, $date_from: String, $date_to: String) {
    listDailyStats(year: $year, username: $username, date_from: $date_from, date_to: $date_to) {
      day
      call_count
    }
  }
`;

export const listAvailableYears = /* GraphQL */ `
  query listAvailableYears {
    listAvailableYears
  }
`;

export const getTimeseriesConfig = /* GraphQL */ `
  query getTimeseriesConfig {
    getTimeseriesConfig {
      config
      updated_at
    }
  }
`;
